import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "fixed top-0 left-0 h-32 pointer-events-none text-white w-full flex z-40" }
const _hoisted_2 = { class: "px-8 lg:px-12 w-full flex flex-1 items-center justify-start justify-end space-x-4 md:space-x-8 relative" }
const _hoisted_3 = { class: "flex items-center justify-start space-x-4" }

import { routes } from "@/constants/";
import LayoutHeaderAvatar from "./LayoutHeaderAvatar.vue";
import AppButton from "@/components/app/AppButton.vue";
import DripversityDvIcon from "@/components/icons/DripversityDvIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LayoutHeader',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "block pointer-events-auto !mr-auto",
        to: "/"
      }, {
        default: _withCtx(() => [
          _createVNode(DripversityDvIcon, { class: "block w-10 lg:w-12" })
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes).socials, (social, name) => {
          return (_openBlock(), _createElementBlock("li", {
            key: name,
            class: "inline-flex items-center justify-center"
          }, [
            _createVNode(AppButton, {
              class: "pointer-events-auto !background-blur-sm",
              color: "blur",
              size: "xs",
              "only-icon": "",
              rounded: "base",
              href: social.baseUrl + '/' + social.account
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(social.icon), { class: "h-3.5 w-3.5" }))
              ]),
              _: 2
            }, 1032, ["href"])
          ]))
        }), 128))
      ]),
      _createVNode(LayoutHeaderAvatar)
    ])
  ]))
}
}

})